
const user = JSON.parse(localStorage.getItem('profile'))

export const initialStatePurchase = {
    items: [],
    total: 0,
    paymentMode:'',
    // notes: user?.userProfile?.paymentDetails,
    // rates: '',
    // vat: 0,
    // currency: '',
    purchaseNumber: Math.floor(Math.random() * 100000),
    // status: '',
   
    creator: '',
}
